import useHotkeys, { KEYS } from '@nicolaudie-group/ng-ui-kit/composables/useHotkeys'
import useReducedState from '@/composables/useReducedState'
import useRouterStore from '@/stores/router.store'
import { watch } from 'vue'

function useDeleteHotkey(activeOnRoutes, enabled, handler) {
  const routerStore = useRouterStore()

  const { active: deletePressed } = useHotkeys(KEYS.Backspace, {
    shift: false,
    alt: false,
    meta: false,
    ctrl: false,
    exact: true,
    disableInTextarea: true,
    disableInInput: true,
    disableInButton: true,
    enabled,
  })

  const dropdownActive = useReducedState(undefined, 'dropdowns')

  watch(deletePressed, (pressed) => {
    if (
      pressed
      && !dropdownActive.value
      && activeOnRoutes.includes(routerStore.route.name)
    ) {
      handler()
    }
  })
}

export default useDeleteHotkey
